module.exports = __webpack_public_path__ + "static/media/thumbnail_ally-ups-adapter@3x.ccc14a89.jpg";